import React from 'react';
import { Helmet } from 'react-helmet';

const EventPage = () => {
  return (
      <div style={styles.page}>
      <Helmet>
          <title>Мир iCandy — новости, выставки, события</title>
          <meta name="description" content="Новости и события iCandy. Участие в выставках, презентация новых коллекций детских колясок." />
      </Helmet>
      {/* Основной блок с информацией о выставке */}
      <header style={styles.header}>
        <h1 style={styles.title}>iCandy примет участие в выставке для будущих мам «Ждем пополнения»</h1>
        <p style={styles.date}>29.03.2025</p>
      </header>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>О выставке</h2>
        <p style={styles.text}>
          День открытых дверей <strong>«Ждем пополнения»</strong> — это масштабное событие, направленное на поддержку будущих родителей. В программе:
        </p>
        <ul style={styles.list}>
          <li><strong>Презентации новинок</strong> от брендов для мам и малышей;</li>
          <li><strong>Мастер-классы и лекции</strong> от врачей, психологов и экспертов по материнству;</li>
          <li><strong>Тест-драйвы детских товаров</strong>, включая коляски, автокресла и аксессуары;</li>
          <li><strong>Специальные предложения и розыгрыши призов</strong> для гостей.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Выступление эксперта</h2>
        <p style={styles.text}>
          Перед гостями выступит <strong>педиатр, детский гастроэнтеролог Ветвинская Наталия Ивановна</strong>, которая даст советы будущим мамам по уходу за малышом.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>iCandy на выставке</h2>
        <p style={styles.text}>
          Бренд <strong>iCandy</strong> представит на выставке свои флагманские модели колясок, сочетающие <strong>инновационный дизайн, безопасность и функциональность</strong>. Посетители смогут лично протестировать наши коляски, задать вопросы представителям бренда и узнать о специальных условиях покупки.
        </p>
        <blockquote style={styles.quote}>
          «Для нас важно быть частью событий, которые объединяют семьи и помогают им сделать осознанный выбор. Мы рады предложить будущим мамам детские коляски премиального качества и аксессуары к ним, которые сделают жизнь проще и комфортнее», — отметили в компании iCandy.
        </blockquote>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Присоединяйтесь!</h2>
        <p style={styles.text}>
          Приглашаем всех на стенд <strong>iCandy</strong>! Вход на выставку свободный по предварительной регистрации на сайте{' '}
          <a href="https://mamadeti.ru" style={styles.link}>https://mamadeti.ru</a>. Не упустите шанс познакомиться с лучшими решениями для материнства и детства!
        </p>
        <p style={styles.text}>
          Ждем вас <strong>29 марта</strong> по адресу: <strong>Одинцовский Г.О., 1-е Успенское шоссе, дом 111/1, корпус Лапино-2, подъезд 40</strong>.
        </p>
        <p style={styles.text}>Парковка на территории <strong>бесплатная</strong>.</p>
      </section>

      <section style={styles.footer}>
        <p style={styles.footerText}>Подробности на сайте <a href="https://mamadeti.ru" style={styles.link}>MamaDeti.ru</a>.</p>
      </section>

      <br/>
      
      {/* Старая статья */}
      <section style={styles.section}>
        <h1 style={styles.header}>Наши коляски iCandy (Великобритания) - в России и в мире</h1>
        <p style={styles.text}>
          Детская коляска эры высоких технологий должна соответствовать многим требованиям, в их числе:
        </p>
        <ul style={styles.list}>
          <li>простота использования</li>
          <li>бескомпромиссная надежность</li>
          <li>красота, радующая глаз</li>
        </ul>
        <p style={styles.text}>
          Коляски мировой торговой марки iCandy остаются неизменными фаворитами у родителей благодаря их отработанному до совершенства дизайну «на все времена», превосходному качеству сборки и практичности, облегчающей заботы повседневности.
        </p>
        <p style={styles.text}>
          Коляски iCandy - это выбор британских знаменитостей. Им отдали предпочтение модный дизайнер и певица Виктория Бэкхем, герцогиня Сассекская Меган Маркл, внучка королевы Елизаветы II Зара Тиндалл — призёр Олимпиады Лондон-2012 по конному спорту (на фото — с коляской iCandy for Land Rover).
        </p>
        <img
          style={styles.image}
          src="diana.jpg"
          alt="Icandy"
        />
        <p style={styles.text}>
          Коляски iCandy предназначены для всех ландшафтов современного мира — от тротуаров оживленных городских улиц до травяных поверхностей парков и лугов, от крутых поверхностей холмов до тенистых лесных тропинок, окружая вашего ребенка комфортом от невероятно мягкой и удобной поездки. Благодаря их легкому и компактному шасси, коляски безальтернативно удобны к перевозке в Вашем автомобиле, использованию в общественном транспорте.
        </p>
        <p style={styles.text}>
          Наша особая гордость — инновационная система складывания шасси коляски, которая даёт возможность удобного размещения в багажнике автомобиля, а также свободу пешего перемещения со сложённой коляской через любые узкие двери и проемы. Длину ручки коляски можно мягко отрегулировать в соответствии с любым предпочтением родителя.
        </p>
        <p style={styles.text}>
          Наша особая гордость — инновационная система складывания коляски, которая даёт возможность удобного размещения в задней части вашего автомобиля, а также свободу пешего перемещения со сложённой коляской через любые узкие двери и проемы.
        </p>
      </section>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#ffffff', // Белый фон
    color: '#000000', // Чёрный текст
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: '1.6',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  title: {
    fontSize: '28px',
    color: '#000000', // Чёрный цвет для заголовка
    marginBottom: '10px',
    fontWeight: '700', // Жирный шрифт
  },
  date: {
    fontSize: '18px',
    color: '#4D4D4D',
  },
  section: {
    marginBottom: '40px',
  },
  sectionTitle: {
    fontSize: '24px',
    color: '#000000', // Чёрный цвет для заголовков секций
    marginBottom: '15px',
    fontWeight: '700', // Жирный шрифт
  },
  articleTitle: {
    fontSize: '28px',
    color: '#000000', // Чёрный цвет для заголовка статьи
    marginBottom: '20px',
    fontWeight: '700', // Жирный шрифт
  },
  text: {
    fontSize: '16px',
    marginBottom: '15px',
    color: '#000000', // Чёрный текст
  },
  list: {
    paddingLeft: '20px',
    fontSize: '16px',
    color: '#000000', // Чёрный текст
    marginBottom: '15px',
  },
  quote: {
    backgroundColor: '#f9f9f9', // Светлый фон для цитаты
    borderLeft: '4px solid #000000', // Чёрная граница
    padding: '15px',
    margin: '20px 0',
    fontStyle: 'italic',
    color: '#000000', // Чёрный текст
  },
  link: {
    color: '#000000', // Чёрный для ссылок
    textDecoration: 'none',
    fontWeight: '600', // Полужирный
    borderBottom: '1px solid #000000', // Подчёркивание для ссылок
  },
  image: {
    display: 'block',
    margin: '20px auto',
    maxWidth: '80%',
    borderRadius: '8px',
  },
  footer: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #cccccc', // Серая граница
  },
  footerText: {
    fontSize: '16px',
    color: '#4D4D4D',
  },
};

export default EventPage;